import React, { useState} from 'react';
import { Button } from 'antd';
import { ProductType, PLAN_OPTIONS } from '@shared/constants/payment';
import './styles.less';

interface PlanOption {
  type: ProductType;
  title: string;
  price: number;
  originalPrice?: number;
  duration: string;
  description: string;
  isRecommended?: boolean;
  discount?: string;
  category?: 'vip' | 'points';
}

interface PlanSelectionProps {
  selectedPlan:  ProductType;
  onPlanSelect: (planType: ProductType) => void;
  onTabChange: (tab: string) => void;
  loading: boolean;
  defaultActiveTab?: 'vip' | 'points';
  onClose: () => void;
}

const PlanSelection: React.FC<PlanSelectionProps> = ({
  selectedPlan,
  onPlanSelect,
  onTabChange,
  loading,
  defaultActiveTab,
  onClose
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab || 'vip');

  const getPlans = () => {
    if (activeTab === 'vip') {
      return PLAN_OPTIONS.filter(plan => plan.category === 'vip');
    }
    return PLAN_OPTIONS.filter(plan => plan.category === 'points');
  };

  const changeTab = (tab: 'vip' | 'points') => {
    setActiveTab(tab);
    onTabChange(tab);
  }

  return (
    <div className="plan-selection">

      <div className="plan-tabs">
        <div 
          className={`plan-tab ${activeTab === 'vip' ? 'active' : ''}`}
          onClick={() => changeTab('vip')}
        >
          VIP会员
        </div>
        <div 
          className={`plan-tab ${activeTab === 'points' ? 'active' : ''}`}
          onClick={() => changeTab('points')}
        >
          橙豆购买
        </div>
      </div>
      {/* 套餐选择 */}
      <div className="plan-options">
        {getPlans().map((plan) => (
          <div
            key={plan.type}
            className={`plan-option ${selectedPlan === plan.type ? 'selected' : ''}  ${loading ? 'disabled' : ''}`}
            onClick={() => !loading && onPlanSelect(plan.type)}
          >
            {plan.discount && (
              <div className="discount-badge">{plan.discount}</div>
            )}
            <div className="plan-title">{plan.title}</div>
            <div className="plan-price">
              <span className="current-price">¥{plan.price}</span>
              {plan.originalPrice && (
                <span className="original-price">原价¥{plan.originalPrice}</span>
              )}
            </div>
            <div className="plan-duration">{plan.duration}</div>
          </div>
        ))}
      </div>

      {/* 试用说明 */}
      <div className="trial-info">
        <p>极具性价比的价格，直接购买即可</p>
        <p>开通会员后每月赠送150橙豆，月内有效</p>
      </div>
    </div>
  );
};

export default PlanSelection;